import {HttpHeaders} from '@angular/common/http';
import {
  AttendantServiceInterface,
  Configuration,
  GetActiveCallsResponse,
  GetAgentSMSLogResponse,
  GetANumberHistoryResponse,
  GetCallLogResponse,
  GetQueuedCallsResponse,
  Response
} from '@gt-api';
import {Observable, of} from 'rxjs';
import {MockData} from '../mock-data';

export class AttendantServiceStub implements AttendantServiceInterface {
  defaultHeaders: HttpHeaders = new HttpHeaders();
  configuration: Configuration;

  clickToCall1(callee: string, displayNumber: string): Observable<Response> {
    return of({code: 200});
  }

  completeTransferCall1(sessionId: number): Observable<Response> {
    return of({code: 200});
  }

  dequeueCall1(sessionId: number): Observable<Response> {
    return of({code: 200});
  }

  dequeueCallToColleague1(sessionId: number, login: string): Observable<Response> {
    return of({code: 200});
  }

  disconnectCall1(sessionId: number, intendedLeg: string): Observable<Response> {
    return of({code: 200});
  }

  getANumberHistory1(
    aNumber: string,
    organization?: string,
    login?: string,
    from?: string,
    to?: string
  ): Observable<GetANumberHistoryResponse> {
    return of({code: 200});
  }

  getActiveCalls1(organization?: string, login?: string): Observable<GetActiveCallsResponse> {
    return of({code: 200, calls: []});
  }

  getAgentCallLog1(organization?: string, login?: string, from?: string, to?: string): Observable<GetCallLogResponse> {
    return of({
      code: 200,
      callLog: []
    });
  }

  getAgentSMSLog1(organization?: string, login?: string, from?: string, to?: string): Observable<GetAgentSMSLogResponse> {
    return of({code: 200, agentSmsLog: []});
  }

  getCallLog1(serviceNumber: string, organization?: string, login?: string, from?: string, to?: string): Observable<GetCallLogResponse> {
    const e1 = MockData.getEndUserById(1);
    const e2 = MockData.getEndUserById(2);
    return of<GetCallLogResponse>({
      code: 200,
      callLog: [
        {aNumber: e1.fullNumber, firstName: e1.firstName, lastName: e1.lastName},
        {aNumber: e2.fullNumber, firstName: e2.firstName, lastName: e2.lastName}
      ]
    });
  }

  getQueuedCalls1(organization?: string, login?: string): Observable<GetQueuedCallsResponse> {
    return of({code: 200, queuedCalls: []});
  }

  parkCall1(sessionId: number): Observable<Response> {
    return of({code: 200});
  }

  retrieveCall1(sessionId: number, intendedLeg: string): Observable<Response> {
    return of({code: 200});
  }

  setCallLogCalledBack1(id: number, organization?: string, login?: string, body?: string): Observable<Response> {
    return of({code: 200});
  }

  setCallLogComment1(id: number, organization?: string, login?: string, body?: string): Observable<Response> {
    return of({code: 200});
  }

  setCallLogHandled1(id: number, organization?: string, login?: string, body?: string): Observable<Response> {
    return of({code: 200});
  }

  toggleCall1(sessionId: number, intendedLeg: string): Observable<Response> {
    return of({code: 200});
  }

  transferCall1(sessionId: number, transferee: string, consultationMode: number): Observable<Response> {
    return of({code: 200});
  }
  transferCallToQueue1(sessionId: number, cid: number, extraHttpRequestParams?: any): Observable<Response> {
    return of({code: 200});
  }
}
